import validate from "/app/code/web-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication from "/app/code/web-frontend/modules/core/middleware/authentication.js";
import manifest_45route_45rule from "/app/code/web-frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  authentication,
  manifest_45route_45rule
]
export const namedMiddleware = {
  settings: () => import("/app/code/web-frontend/modules/core/middleware/settings.js"),
  authenticated: () => import("/app/code/web-frontend/modules/core/middleware/authenticated.js"),
  workspacesAndApplications: () => import("/app/code/web-frontend/modules/core/middleware/workspacesAndApplications.js"),
  pendingJobs: () => import("/app/code/web-frontend/modules/core/middleware/pendingJobs.js"),
  staff: () => import("/app/code/web-frontend/modules/core/middleware/staff.js"),
  impersonate: () => import("/app/code/web-frontend/modules/core/middleware/impersonate.js"),
  urlCheck: () => import("/app/code/web-frontend/modules/core/middleware/urlCheck.js"),
  dashboardRedirect: () => import("/app/code/web-frontend/modules/core/middleware/dashboardRedirect.js"),
  tableLoading: () => import("/app/code/web-frontend/modules/database/middleware/tableLoading.js"),
  selectWorkspaceDatabaseTable: () => import("/app/code/web-frontend/modules/database/middleware/selectWorkspaceDatabaseTable.js"),
  dashboardLoading: () => import("/app/code/web-frontend/modules/dashboard/middleware/dashboardLoading.js"),
  selectWorkspaceBuilderPage: () => import("/app/code/web-frontend/modules/builder/middleware/selectWorkspaceBuilderPage.js")
}